import { timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
export var locationEnvironmentNameUniqueAsyncValidator = function (_a) {
    var locationEnvironmentApi = _a.locationEnvironmentApi, locationSectorId = _a.locationSectorId, locationEnvironmentId = _a.locationEnvironmentId;
    return function (control) {
        var name = control.value;
        if (!locationSectorId) {
            return timer(0)
                .pipe(map(function () { return null; }));
        }
        return timer(500)
            .pipe(switchMap(function () { return locationEnvironmentApi.search({
            where: {
                nameEq: name,
                locationSectorId: locationSectorId,
            },
            limit: 1,
            offset: 0,
        }); }), map(function (_a) {
            var items = _a.items;
            return items.some(function (item) { return item.id !== locationEnvironmentId; })
                ? { nameAlreadyExists: true }
                : null;
        }));
    };
};
